import * as React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
// graphql
import { USERS_LIST_QUERY } from 'graphql/user/queries'
// types
import { IUser, IUsersResponse } from 'types/graphql'
import { NGetUsers } from 'types/user/helpers'
import { TRefetch } from 'types/refetch'
// utils
import get from 'lodash/get'

type Props = React.PropsWithChildren<unknown>

type QueryResponse = {
  users: IUsersResponse
}

interface IContext {
  data: IUser[]
  refetch: TRefetch<QueryResponse, NGetUsers.IVariables>
  isLoading: boolean
  totalCount: number
  isRefetching: boolean
}

export const UsersPageContext = React.createContext<IContext>({} as any)

const UsersPageAPI: React.FC<Props> = ({ children }) => {
  const { filter, page, perPage, search } = React.useContext(TableManagementContext)

  const { data, networkStatus, refetch } = useQuery<QueryResponse>(USERS_LIST_QUERY, {
    fetchPolicy: 'cache-and-network',
    variables: {
      filter: {
        ...filter,
        name: search
      },
      pagination: {
        pageSkip: page * perPage,
        pageTake: perPage
      }
    }
  })

  const users = get(data, 'settingsUsers.data', [])
  const totalCount = get(data, 'settingsUsers.pagination.totalCount')

  const value = {
    refetch,
    totalCount,
    data: users,
    isLoading: networkStatus === 1,
    isRefetching: networkStatus === 2
  }

  return <UsersPageContext.Provider value={value}>{children}</UsersPageContext.Provider>
}

export default UsersPageAPI
